// Sentry initialization should be imported first!
import './instrument';

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ChunkLoadErrorBoundary } from './components/ChunkLoadErrorBoundary'

// Solution 1: Handle Vite chunk preload errors (CLASSELLA-1C)
// This catches stale chunk references after deployment and auto-refreshes the page
window.addEventListener('vite:preloadError', (event: Event) => {
  // Prevent the default error from propagating
  event.preventDefault();

  console.error('[CLASSELLA-1C] Chunk preload failed, refreshing page:', {
    timestamp: new Date().toISOString()
  });

  // Prevent infinite refresh loops
  const lastRefresh = sessionStorage.getItem('lastChunkLoadRefresh');
  const now = Date.now();
  if (!lastRefresh || now - parseInt(lastRefresh) > 10000) {
    sessionStorage.setItem('lastChunkLoadRefresh', now.toString());
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ChunkLoadErrorBoundary>
      <App />
    </ChunkLoadErrorBoundary>
  </StrictMode>,
)
